import React, { useState, useCallback } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { FormGroup, FormControlLabel, Typography, CircularProgress, TextField } from '@mui/material';
import MUICheckbox from './MUICheckbox'; // Assuming you have a custom checkbox component

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

interface PropsType {
    closeModal: () => void;
    columnListData: string[]; // Updated to handle the key-value pair structure
    columnLoading: boolean;
    handleDownload: (selectedFields: string[]) => void;
    jiraID: string;
}

function CustomTabPanel(props: TabPanelProps): JSX.Element {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function ConvertDataExport({
    columnListData,
    columnLoading,
    jiraID,
    closeModal,
    handleDownload
}: PropsType): JSX.Element {
    const [value, setValue] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    const [selectedFields, setSelectedFields] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState('');

    // Ensure columnListData is an object before filtering
    const filteredColumnList = Object.entries(columnListData).filter(([field]) =>
        field.toLowerCase().includes(inputValue.toLowerCase())
    );

    const handleChange = (event: React.SyntheticEvent, newValue: number): void => {
        setValue(newValue);
    };

    const handleSelectAll = useCallback((): void => {
        setSelectAll(prevSelectAll => !prevSelectAll);
        setSelectedFields(() =>
            !selectAll ? filteredColumnList.map(([field]) => field) : []
        );
    }, [selectAll, filteredColumnList]);

    const handleFieldSelection = useCallback((field: string): void => {
        setSelectedFields(prevSelectedFields => {
            const updatedSelection = prevSelectedFields.includes(field)
                ? prevSelectedFields.filter(item => item !== field)
                : [...prevSelectedFields, field];
            
            // Update Select All state based on selection
            setSelectAll(updatedSelection.length === filteredColumnList.length);
            return updatedSelection;
        });
    }, [filteredColumnList]);

    function a11yProps(index: number): { id: string; 'aria-controls': string } {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <>
    <Box className="px-[16px] pt-[10px]  mb-[10px]">
  <TextField
    id="outlined-basic"
    label="Jira ID"
    variant="outlined"
    fullWidth
    name="Description"
    value={jiraID}
    autoComplete="off"
    InputProps={{
      style: {
        textAlign: 'center',
        color: '#000000',
        fontSize: '18px',
        fontWeight: '700',
        WebkitTextFillColor: '#000000',
        
      },
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#e0e0e0', // Gray background color
        '& fieldset': {
          borderColor: '#d0d0d0',
        },
        '&:hover fieldset': {
          borderColor: '#b0b0b0',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#D6242C',
        },
      },
      '& input': {
        textAlign: 'center',
        padding: '7px', // Adjust padding to fit within the TextField
        color: '#000000 !important',
        fontSize: '18px !important',
        fontWeight: '700 !important',
        '-webkit-text-fill-color': '#000000 !important',
        opacity: '1 !important',
        backgroundColor: '#f5f5f5 !important', // Ensure background color is applied
      },
      '& label': {
        textAlign: 'center',
        color: '#343434',
        top: '-6px', // Adjust label position to account for increased padding
      },
      '& label.Mui-focused': {
        color: '#D6242C',
      },
    }}
    InputLabelProps={{
      shrink: true,
    }}
    disabled
  />
</Box>



            <div>
            <Box sx={{ width: '100%', padding: 0}}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#D6242C",
                            }
                        }}
                    >
                        <Tab label="Data fields" {...a11yProps(0)} sx={{
                            color: '#D6242C',
                            fontWeight: '600',
                            '&.Mui-selected': {
                                color: '#D6242C',
                            },
                            paddingLeft:'22px' 
                        }} />
                    </Tabs>
                </Box>

                <div className="form-control  border-b-[1px] border-[#D9D9D9] pb-2 w-full pt-2" style={{ borderTop: 'none' }}>
  <input
    type="text"
    placeholder="Search fields"
    onChange={(e) => setInputValue(e.target.value)}
    style={{
      border: '0',
      background: 'transparent url(/assets/images/icons/SearchIcon.svg) no-repeat 22px',
      paddingLeft: '50px',
      fontSize: '14px',
      fontWeight: '400',
      color: '#3a3a3a',
      width: '100%', // Ensure the field takes the full width
    }}
  />
</div>
                <CustomTabPanel value={value} index={0}>
                    
             

                        
                 

                            <div style={{ padding: '0 ' }}>
    {columnLoading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '16px' }}>
            <CircularProgress />
        </div>
    ) : (
        <div style={{ paddingLeft:'8px',marginBottom: '40px' }}>
          {filteredColumnList.length > 0 &&
            <FormGroup>
                <FormControlLabel
                    control={<MUICheckbox checked={selectAll} onChange={handleSelectAll} />}
                    label={<Typography  sx={{ fontWeight: 'bold', fontSize: '14px',
                      color: '#3a3a3a' }}>Select All</Typography>}
                />
            </FormGroup>
}
            {filteredColumnList.length > 0 ? (
                filteredColumnList.map(([field], index) => (
                  <div style={{ padding: '0 16px 5px 20px' }} key={index}>
                    <FormGroup key={index}>
                        <FormControlLabel
                            control={<MUICheckbox checked={selectedFields.includes(field)} onChange={() => handleFieldSelection(field)} />}
                            label={<Typography>{`${field}`}</Typography>}
                        />
                    </FormGroup>
                    </div>
                ))
            ) : (
                <Typography variant="body2" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '14px' }}>
                   There are no records to display.
                </Typography>
            )}
        </div>
    )}
</div>

                </CustomTabPanel>
            </Box>
           </div>
           <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" onClick={closeModal} >Cancel</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button className={`btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]${
      columnLoading || selectedFields.length === 0
        ? 'from-[#F08080] to-[#F08080] cursor-not-allowed'
        : 'from-[#ED4B52] to-[#D6242C]'
    }`}
    disabled={columnLoading || selectedFields.length === 0} 
    onClick={() => handleDownload(selectedFields)}>{!columnLoading ? 'Export' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                </div>
            </div>
           
        </>
    );
}

export default ConvertDataExport;
